export const SetupMenu = {
  routes: [
    {
      name: 'general-setup',
      displayName: 'menu.general_setups',
      subject_class: "SetupMenu"
    },
    {
      name: 'setup-initial',
      displayName: 'menu.setup_initial',
      subject_class: "SetupMenu"
    },
    {
      name: 'pallets',
      displayName: 'menu.pallets',
      subject_class: "Pallets"
    },
    {
      name: 'files',
      displayName: 'menu.files',
      subject_class: "SetupMenu"
    },
  ]
}
